module.exports = __webpack_public_path__ + "static/img/cover.ae56040.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/glassesgallery/cover.jpg
// module id = OL8e
// module chunks = 1